import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import dayjs from 'dayjs'

Vue.config.productionTip = false

Vue.filter('dateformat', value => dayjs(value).format('DD/MM/YYYY'))

new Vue({
    router,
    render: h => h(App),
    data: {
        isProduction: Boolean(process.env.VUE_APP_API_BASE_URL == 'https://frontend.affinium.fr/')
    }
}).$mount('#app')
